import React from 'react';
import { ShieldIcon, CircleCheckIcon, LockIcon, DownloadIcon, CalendarIcon } from './Icons';
export const Guarantee = () => {
  return <section className="w-full bg-white py-8 md:py-12 px-4 md:px-6" data-id="element-71">
      <div className="max-w-[700px] mx-auto flex flex-col items-center" data-id="element-72">
        <ShieldIcon color="#957DAD" size={64} className="mb-5" data-id="element-73" />

        <h2 className="font-playfair text-[26px] md:text-[36px] text-primary text-center mb-5" data-id="element-74">
          30-Day Total Guarantee
        </h2>

        <p className="font-lato text-[16px] md:text-[17px] text-secondary text-center leading-[1.8] mb-8" data-id="element-75">
          Try the method for 30 full days. If you do not see any change in your
          energy, digestion or symptoms... we will refund every cent. No
          questions. No forms. No drama.
        </p>

        <div className="w-full border-[2px] border-medium rounded-[20px] p-6 md:p-10 bg-gradient-to-br from-white to-light shadow-[0_8px_32px_rgba(149,125,173,0.15)] flex flex-col items-center" data-id="element-76">
          <div className="flex flex-col md:flex-row gap-3 md:gap-4 w-full justify-center" data-id="element-77">
            <div className="bg-light text-medium font-lato font-bold text-[13px] py-[10px] px-[18px] rounded-[50px] border border-accent inline-flex items-center justify-center gap-2" data-id="element-78">
              <CircleCheckIcon color="#957DAD" size={16} data-id="element-79" />
              <LockIcon color="#957DAD" size={16} data-id="element-80" />
              <span data-id="element-81">Secure SSL Payment</span>
            </div>
            <div className="bg-light text-medium font-lato font-bold text-[13px] py-[10px] px-[18px] rounded-[50px] border border-accent inline-flex items-center justify-center gap-2" data-id="element-82">
              <CircleCheckIcon color="#957DAD" size={16} data-id="element-83" />
              <DownloadIcon color="#957DAD" size={16} data-id="element-84" />
              <span data-id="element-85">Instant Access</span>
            </div>
            <div className="bg-light text-medium font-lato font-bold text-[13px] py-[10px] px-[18px] rounded-[50px] border border-accent inline-flex items-center justify-center gap-2" data-id="element-86">
              <CircleCheckIcon color="#957DAD" size={16} data-id="element-87" />
              <CalendarIcon color="#957DAD" size={16} data-id="element-88" />
              <span data-id="element-89">No Subscription</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
};